/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type EpsiDocsRetryCreateRequest = {} | null | undefined;
export type EpsiDocsRetryCreateResponse = any;

export type EpsiDocsRetryCreateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this epsi doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * POST /dmx-server/epsi_docs/{id}/retry/
 *
 * ```yaml
 * operationId: epsi_docs_retry_create
 * description: |-
 *   Ruční retry jedné sady (stavové i změnové) podle jejího stavu.
 *
 *   Synchronizační tlačítko / cron existující sadu ignoruje — retry je
 *   jediná cesta, jak zaseknutou/selhanou sadu oživit hned. Download stavy
 *   (WAITING_FOR_DOWNLOAD, DOWNLOAD_FAILED) se znovu stáhnou (R46 dotaz
 *   synchronně kvůli fail-fast, stažení na pozadí) a předají Georeálu;
 *   IMPORT_FAILED se jen znovu předá — data na disku zůstala (kryje i
 *   obsahové odmítnutí Georeálem, viz PspiImportProcessFlow). IMPORTED se
 *   neretryuje. U změnové sady drží pořadí fronta: po úspěšném importu se
 *   sám řetězí další čekající den, po dalším selhání se fronta znovu
 *   zastaví; den překonaný dokončeným stavovým otiskem retry odmítne.
 * tags:
 *   - epsi_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '202':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/epsi_docs_retry_detail'
 *     description: Retry přijat — průběh sledujte v listingu / přes SSE.
 *   '403':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/epsi_docs_retry_detail'
 *     description: Chybí oprávnění — ACL resource `EpsiDocs`, akce `retry`.
 *   '409':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/epsi_docs_retry_detail'
 *     description: >-
 *       Sadu nelze retryovat — nepodporovaný stav, sada překonaná dokončeným
 *       novějším stavovým otiskem, nebo den už není v nabídce ČÚZK.
 *   '502':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/epsi_docs_retry_detail'
 *     description: R46 dotaz na IS DMVS selhal — detail ve worklistu external_failures.
 * ```
 */
export const epsiDocsRetryCreateOperation = ({ id, ...rest }: EpsiDocsRetryCreateQuery) =>
  ({
    method: 'POST',
    path: `/dmx-server/epsi_docs/${id}/retry/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/epsi_docs/{id}/retry/' };
  };

/**
 * POST /dmx-server/epsi_docs/{id}/retry/
 *
 * ```yaml
 * operationId: epsi_docs_retry_create
 * description: |-
 *   Ruční retry jedné sady (stavové i změnové) podle jejího stavu.
 *
 *   Synchronizační tlačítko / cron existující sadu ignoruje — retry je
 *   jediná cesta, jak zaseknutou/selhanou sadu oživit hned. Download stavy
 *   (WAITING_FOR_DOWNLOAD, DOWNLOAD_FAILED) se znovu stáhnou (R46 dotaz
 *   synchronně kvůli fail-fast, stažení na pozadí) a předají Georeálu;
 *   IMPORT_FAILED se jen znovu předá — data na disku zůstala (kryje i
 *   obsahové odmítnutí Georeálem, viz PspiImportProcessFlow). IMPORTED se
 *   neretryuje. U změnové sady drží pořadí fronta: po úspěšném importu se
 *   sám řetězí další čekající den, po dalším selhání se fronta znovu
 *   zastaví; den překonaný dokončeným stavovým otiskem retry odmítne.
 * tags:
 *   - epsi_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '202':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/epsi_docs_retry_detail'
 *     description: Retry přijat — průběh sledujte v listingu / přes SSE.
 *   '403':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/epsi_docs_retry_detail'
 *     description: Chybí oprávnění — ACL resource `EpsiDocs`, akce `retry`.
 *   '409':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/epsi_docs_retry_detail'
 *     description: >-
 *       Sadu nelze retryovat — nepodporovaný stav, sada překonaná dokončeným
 *       novějším stavovým otiskem, nebo den už není v nabídce ČÚZK.
 *   '502':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/epsi_docs_retry_detail'
 *     description: R46 dotaz na IS DMVS selhal — detail ve worklistu external_failures.
 * ```
 */
export const epsiDocsRetryCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: EpsiDocsRetryCreateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = epsiDocsRetryCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
